module.exports = __webpack_public_path__ + "img/error-image.6362140e.svg";